import { render, staticRenderFns } from "./CreateNewMobile.vue?vue&type=template&id=47cabc01&scoped=true&"
import script from "./CreateNewMobile.vue?vue&type=script&lang=js&"
export * from "./CreateNewMobile.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewMobile.vue?vue&type=style&index=0&id=47cabc01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cabc01",
  null
  
)

export default component.exports